import { createStyles, Text, TextProps } from '@mantine/core'
import React, { ReactElement } from 'react'

export type TReadonlyInputProps = {
  value?: string
  suffix?: string
  align?: TextProps['align']
  format?: (value: any) => string
  dimmed?: boolean
  bigger?: boolean
  hideEmptyValue?: boolean
  hideValue?: boolean
  bolder?: boolean
}

const useStyle = createStyles((theme) => ({
  root: {
    height: 'calc(1.5em + 0.9rem + 2px)',
    paddingLeft: '2px',
    paddingRight: '2px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'stretch',
  },
}))

const ReadonlyInput = (props: TReadonlyInputProps): ReactElement => {
  const {
    value,
    suffix,
    align,
    format = (v) => v,
    dimmed,
    bigger,
    bolder,
    hideEmptyValue,
    hideValue,
  } = props

  const { classes } = useStyle()

  const content = (
    <>
      {format(value)}
      {suffix ?? ''}
    </>
  )

  if ((hideEmptyValue && !value) || hideValue) {
    return (
      <>
        <div />
      </>
    )
  }

  return (
    <>
      <div className={classes.root}>
        {bigger ? (
          <div className="flex-fill">
            <h4 className="mt-1 text-center">{content}</h4>
          </div>
        ) : bolder ? (
          <div className="flex-fill">
            <h5 className="mt-1 text-center">{content}</h5>
          </div>
        ) : (
          <Text
            align={align}
            className="flex-fill"
            color={dimmed ? 'dimmed' : undefined}
          >
            {content}
          </Text>
        )}
      </div>
    </>
  )
}

export default ReadonlyInput
